export default __webpack_public_path__ + "static/media/Pp.b71ecb9c.wav";